import { css } from "styled-components";

const sizes = {
  phone: 576,
  tablet: 768,
  desktop: 992,
  wideScreen: 1200
};

const media = Object.keys(sizes).reduce((acc, label) => {
  acc[`${label}Up`] = (...args) => css`
    @media (min-width: ${sizes[label]}px) {
      ${css(...args)};
    }
  `;
  acc[`${label}Down`] = (...args) => css`
    @media (max-width: ${sizes[label]}px) {
      ${css(...args)};
    }
  `;
  return acc;
}, {});

const colors = {
  white: "#FFFFFF",
  black: "#000000",
  // Module design system colors
  green1: "#EEF2E3",
  green2: "#C8F169",
  green3: "#78C51C",
  green4: "#2A6F2B",
  green5: "#043F2E",

  blue1: "#DDE7FA",
  blue2: "#BBD1FB",
  blue3: "#7EA6F3",
  blue4: "#3D70D4",
  blue5: "#2C5BB6",

  violet1: "#E6E4FC",
  violet2: "#CCC8FF",
  violet3: "#A68FFF",
  violet4: "#7456CE",
  violet5: "#5F41B7",

  coral1: "#F8DFE3",
  coral2: "#FFBBC6",
  coral3: "#FB8492",
  coral4: "#CC416B",
  coral5: "#B22447",

  gray1: "#FCFCFC",
  gray2: "#F8F9F7",
  gray3: "#F3F5F3",
  gray4: "#EAEDE8",
  gray5: "#DFE2DE",
  gray6: "#CED1CD",
  gray7: "#B6BAB4",
  gray8: "#7F827E",
  gray9: "#6C6E6B",
  gray10: "#5A5C58",
  gray11: "#3D3D3B",
  gray12: "#242524",

  productLightYellow: "#F7F1DA",
  productYellow: "#E7C03A",
  productLightGreen: "#E6F7DF",
  productGreen: "#26992B",
  productLightRed: "#FFE9E9",
  productRed: "#CD1515",

  // Legacy design colors
  // GRAYS
  gray100: "#FCFCFC",
  gray200: "#F7F7F9",
  gray300: "#F1F2F5",
  gray400: "#E4E7ED",
  gray500: "#D6D9DE",
  gray600: "#C9CAD1",
  gray700: "#B1B2BA",
  gray800: "#757782",
  gray900: "#63656E",
  gray1000: "#53535C",
  gray1100: "#393945",
  gray1200: "#191925",
  // GREENS
  green100: "#D9F2E4",
  green200: "#9EE8B8",
  green300: "#6CE397",
  green400: "#51CB80",
  green500: "#37B067",
  green600: "#26A05A",
  green700: "#128A48",
  green800: "#067A3B",
  green900: "#165537",
  // BLUES
  blue100: "#DCEFF6",
  blue200: "#A3E0FF",
  blue300: "#83DBFF",
  blue400: "#68C3EC",
  blue500: "#4CAED9",
  blue600: "#379FC9",
  blue700: "#198CB5",
  blue800: "#067EA6",
  blue900: "#14495E",
  // PINKS
  pink100: "#F9DCE3",
  pink200: "#FFA5BC",
  pink300: "#FF89AB",
  pink400: "#EB6E90",
  pink500: "#D9577A",
  pink600: "#C6466D",
  pink700: "#B1345C",
  pink800: "#A2234F",
  pink900: "#611D30",
  // PURPLES
  purple100: "#D9D4ED",
  purple200: "#8B7CCE",
  purple300: "#695BBD",
  purple400: "#5346A4",
  purple500: "#3D318C",
  purple600: "#2C227C",
  purple700: "#170E66",
  purple800: "#060057",
  purple900: "#191148",
  // REDS
  red100: "#F2D5CF",
  red200: "#FF988F",
  red300: "#FF7672",
  red400: "#EC625F",
  red500: "#D74C4C",
  red600: "#DA364A",
  red700: "#BD3647",
  red800: "#AF2D3E",
  red900: "#731D21",
  // YELLOWS
  yellow100: "#FFFEDE",
  yellow200: "#FFF7BC",
  yellow300: "#FFEC94",
  yellow400: "#F8DD7C",
  yellow500: "#F0CA62",
  yellow600: "#DDB547",
  yellow700: "#C59B2B",
  yellow800: "#B38714",
  yellow900: "#74621E",
  // ORANGES 🍊
  orange100: "#FAEFD9",
  orange200: "#FFD087",
  orange300: "#FFC066",
  orange400: "#EDA94E",
  orange500: "#D99036",
  orange600: "#C78227",
  orange700: "#B37112",
  orange800: "#A26101",
  orange900: "#61440A"
};

const fonts = {
  grenette: css`'Grenette', 'Helvetica Neue', Helvetica, Arial, sans-serif`,
  graphik: css`'Graphik', 'Helvetica Neue', Helvetica, Arial, sans-serif`,
  atlas: css`'Atlas Typewriter', monospace, cursive`
};

const motion = {
  short: "0.4s",
  medium: "0.8s",
  long: "1.2s"
};

const grid = value => {
  return `${value * 8}px`;
};

const theme = {
  media,
  sizes,
  colors,
  fonts,
  motion,
  grid
};

export default theme;
